import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { ClienteModel } from 'src/app/models/cliente';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { BodyEnvio3 } from 'src/app/interfaces/body-envio3';
import { OrquestadorService } from 'src/app/services/orquestador/orquestador.service';
import { BodyEnvio2 } from 'src/app/interfaces/body-envio2';
import { ResponseServices } from 'src/app/interfaces/response-services';
import { BodyCotPausa } from 'src/app/interfaces/body_cotPausa';
import { BodyNoPasaPoliticas } from 'src/app/interfaces/body_noPasaPoliticas';
import { FEEDBACK, TIEMPO_INACTIVO } from 'src/app/routes.constants';

@Component({
  selector: 'app-cotizacion-pausa2',
  standalone: false,
  templateUrl: './cotizacion-pausa2.component.html',
  styleUrl: './cotizacion-pausa2.component.scss'
})

export class CotizacionPausa2Component implements OnInit {

  @ViewChild('nombreCliente') nombreCliente2!: ElementRef;
  @ViewChild('numCelular') numCelular2!: ElementRef;
  @ViewChild('correo') correoElec2!: ElementRef;
  emailPattern = environment.PATTERN_EMAIL;
  celularPattern = environment.PATTERN_CELULAR;
  // datosPersonales!: DatosPersonales;

  dato1: string = '';
  json: string = '';
  jsonFinal: string = '';
  sessionId: string = '';
  completo: string[] = [];

  leadId: string = '';
  msnPantalla: string = '';
  dataEnvio40Min!: BodyEnvio3;
  dataEnvio!: BodyEnvio2;
  response!: ResponseServices;
  porcPantalla: string = '';
  codAsesor: string = '';
  isMouseMove: any;
  checador: any;
  saliendo: boolean = false;
  parametro: string = '';
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor

  private datosGenerales: DatosGeneralesModel = {
    Cliente: {
      cedulaCliente: '',
      celularCliente: '',
      nombreCliente: '',
      tipoIdentificacion: ''
    },
    InfoArrendamiento: {
      tipoPropiedad: '',
      ubicacion: '',
      valorAdministracion: 0,
      valorArriendo: 0,
      fechaContrato: '',
      duracionContrato: '',
      ServiciosPublicos: false,
      PaquetesAsistencia: false
    },
    Propietario: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      paisNacimiento: '',
      tipoIdentificacion: '',
      numeroIdentificacion: '',
      fechaExpedicion: '',
      correo: ''
    },
    PlanSeleccionado: {
      plan: '',
      valorPlan: 0
    },
    Inmueble: {
      ciudad: '',
      direccion: '',
      maticula: ''
    },
    Inquilino: {
      primerNombre: '',
      segundoNombre: '',
      primerApellido: '',
      segundoApellido: '',
      numCelular: '',
      correo: '',
      paisNacimento: '',
      fechaNacimento: '',
      tipoidentificacion: '',
      documentoIdentidad: '',
      fechaExpedicion: '',
      ciudad: '',
      direccion: ''
    },
    ResponseRiesgoConsultable: [
      {
        esRiesgo: false,
        tipoValidacion: '',
        mensajeValidacion: '',
        idRegistroValidacion: ''
      }
    ]
  }

  private cotizacionPausa: BodyCotPausa = {
    leadId: '',
    SessionId: '',
    asesorCode: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        Mail: ''
      }
    }
  }

  private noPasaPoliticas: BodyNoPasaPoliticas = {
    SessionId: '',
    productFamily: '',
    leadId: '',
    screenPercentage: '',
    leadRequeriment: '',
    asesorCode: '',
    bitacoraId: '',
    productsConfigurationData: {
      PolicyHolder: {
        LastName: '',
        MobilePhone: '',
        PersonalDataAuthorization: false
      },
      Tenant: {
        DocumentType: '',
        DocumentNumber: ''
      },
      Property: {
        AdministrationValue: 0,
        RentalFee: 0,
        Department: '',
        UseProperty: ''
      }
    }
  }
  IdBitacora: string = '';

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(e: MouseEvent) {
    let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
    this.isActivity = true;
    nuevaPosicionX = e.clientX;
    nuevaPosicionY = e.clientY;

    if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
      clearTimeout(this.checador);
      this.checador = setTimeout(() => {

        if (this.saliendo == false) {
          this.isActivity = false;
          this.saliendo = true;
          clearInterval(this.isMouseMove);
          clearTimeout(this.checador);
          this.router.navigate([TIEMPO_INACTIVO, { idLead: this.leadId, porcPll: this.porcPantalla, msnPll: this.msnPantalla, infoViaje: btoa(this.parametro) }]);
        }
      }, this.localTimer);
    }

    posicionX = e.clientX;
    posicionY = e.clientY;
  }


  formulario: FormGroup = new FormGroup(
    {
      nombreCliente: new FormControl('', [Validators.required]),
      numCelular: new FormControl('', [Validators.minLength(6), Validators.maxLength(10), Validators.pattern(this.celularPattern)]),
      correo: new FormControl('', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]),
      flexCheckAutoriza: new FormControl(false),
    }
  );

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orquestadorService: OrquestadorService
  ) { }


  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      this.porcPantalla = params.getAll('porcPll')[0];
      this.msnPantalla = params.getAll('msnPll')[0];
      this.leadId = params.getAll('idLead')[0];
      const resultado = params.get('infoViaje');
      this.codAsesor = params.getAll('codigoAsesor')[0];
      this.IdBitacora = params.getAll('bitacoraId')[0];

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosGenerales = JSON.parse(this.jsonFinal);
      }
    });

    this.formulario.get("nombreCliente")?.setValue(this.datosGenerales.Propietario.primerNombre);
  }

  cotizacionEnPausa(): void {
    switch (this.porcPantalla) {
      case '30':
        this.GuardaNoPasaPoliticas();
        break;
      default:
        this.GuardarDataLayer();
        break;
    }
  }

  llenarDatosPersonales(dataCliente: ClienteModel) {
    if (dataCliente !== undefined) {
      this.completo = dataCliente.nombreCliente.split(' ');
      this.dato1 = this.completo[0];
    }
  }

  valNombre = false;
  valNombre2 = true;
  validacionNombre() {
    if (this.formulario.get("nombreCliente")?.value === '') {
      this.valNombre = !this.valNombre;
      this.valNombre2 = !this.valNombre2;
    } else {
      this.valNombre = false;
      this.valNombre2 = true;
    }
  }

  valCelular = false;
  valCelular2 = true;
  validacionCelular() {
    if (this.formulario.get("numCelular")?.value === '') {
      this.valCelular = !this.valCelular;
      this.valCelular2 = !this.valCelular2;
    } else {
      this.valCelular = false;
      this.valCelular2 = true;
    }
  }

  valEmail = false;
  valEmail2 = true;
  validacionEmail() {
    if (this.formulario.get("correo")?.value === '') {
      this.valEmail = !this.valEmail;
      this.valEmail2 = !this.valEmail2;
    } else {
      this.valEmail = false;
      this.valEmail2 = true;
    }
  }

  get nombreNoValido() {
    return this.formulario.get("nombreCliente")?.invalid
      && this.formulario.get("nombreCliente")?.touched;
  }

  get correoNoValido() {
    return this.formulario.get("correo")?.invalid
      && this.formulario.get("correo")?.touched;
  }

  get cedularNoValido() {
    return this.formulario.get("numCelular")?.invalid
      && this.formulario.get("numCelular")?.touched;
  }

  get formularioNoValido() {
    return this.formulario.invalid
  }

  Enviar() {
    this.GuardarDataLayer();
    this.router.navigate([FEEDBACK]);
  }

  private GuardarDataLayer() {
    this.cotizacionPausa.leadId = this.leadId;
    this.cotizacionPausa.SessionId = this.sessionId;

    if (this.codAsesor != "0") {
      this.cotizacionPausa.asesorCode = this.codAsesor;
    }

    this.cotizacionPausa.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value;
    this.cotizacionPausa.productsConfigurationData.PolicyHolder.Mail = this.formulario.get("correo")?.value
    this.cotizacionPausa.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value;

    this.orquestadorService.postOrquestadorEnvioGen(this.cotizacionPausa).
      subscribe(
        (data) => {
          this.response = data;
          this.router.navigate([FEEDBACK]);
        }
      );
  }

  private GuardaNoPasaPoliticas() {
    this.noPasaPoliticas.SessionId = this.sessionId;
    this.noPasaPoliticas.productFamily = 'Arrendamiento';
    this.noPasaPoliticas.leadId = this.leadId;
    this.noPasaPoliticas.screenPercentage = this.porcPantalla;

    if (this.codAsesor != "0") {
      this.noPasaPoliticas.asesorCode = this.codAsesor;
    }

    this.noPasaPoliticas.bitacoraId = this.IdBitacora;
    this.noPasaPoliticas.leadRequeriment = 'Valor maximo de cannon + administración  || uso del inmueble';
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.LastName = this.formulario.get("nombreCliente")?.value;
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.MobilePhone = this.formulario.get("numCelular")?.value;;
    this.noPasaPoliticas.productsConfigurationData.PolicyHolder.PersonalDataAuthorization = this.formulario.get("flexCheckAutoriza")?.value;
    this.noPasaPoliticas.productsConfigurationData.Tenant.DocumentType = this.datosGenerales.Inquilino.tipoidentificacion;
    this.noPasaPoliticas.productsConfigurationData.Tenant.DocumentNumber = this.datosGenerales.Inquilino.documentoIdentidad;
    this.noPasaPoliticas.productsConfigurationData.Property.AdministrationValue = this.datosGenerales.InfoArrendamiento.valorAdministracion;
    this.noPasaPoliticas.productsConfigurationData.Property.RentalFee = this.datosGenerales.InfoArrendamiento.valorArriendo;
    this.noPasaPoliticas.productsConfigurationData.Property.Department = this.datosGenerales.Inmueble.direccion;
    this.noPasaPoliticas.productsConfigurationData.Property.UseProperty = this.datosGenerales.InfoArrendamiento.tipoPropiedad;
    this.noPasaPoliticas.productsConfigurationData.Property.Code = this.datosGenerales.InfoArrendamiento.Code;
    this.noPasaPoliticas.productsConfigurationData.Property.CityCode = this.datosGenerales.InfoArrendamiento.CityCode;
    this.noPasaPoliticas.productsConfigurationData.Property.DepartmentCode = this.datosGenerales.InfoArrendamiento.DepartmentCode;
    this.noPasaPoliticas.productsConfigurationData.Property.CityProperty = this.datosGenerales.InfoArrendamiento.CityProperty;

    this.orquestadorService.postOrquestadorEnvioGen(this.noPasaPoliticas).
      subscribe(
        (data) => {
          this.response = data;
        }
      );
  }
}
